module.exports = __webpack_public_path__ + "static/media/cancel.cad70081.svg";